<ng-template #overviewRow [appLinkedItemTableOverview]="itemKey" let-item>
    <td>
        <span class="item-name">{{ item.name }}</span>
        @if (item.identifier) {
            <span class="item-reference">{{ 'identifier' | t: { identifier: item.identifier } }}</span>
        }
    </td>
    <td>
        @if (item.score) {
            <app-cerrix-color-box-label [label]="item.score" [color]="item.scoreColor" />
        }
    </td>
</ng-template>
<ng-template #detailRow [appLinkedItemTableDetail]="detailContext" let-item let-details="details">
    <div class="detail-content">
        <dl>
            <dt>{{ 'linkedItems.controls.identifierLabel' | t: {} : assetManagementScope }}</dt>
            <dd data-uiid="linked-control-detail-identifier">{{ details.identifier }}</dd>
            <dt>{{ 'linkedItems.controls.nameLabel' | t: {} : assetManagementScope }}</dt>
            <dd data-uiid="linked-control-detail-name">{{ details.name }}</dd>
            <dt>{{ 'linkedItems.controls.scoreHeader' | t: {} : assetManagementScope }}</dt>
            <dd data-uiid="linked-control-detail-score">
                @if (details.score) {
                    <app-cerrix-color-box-label [label]="details.score" [color]="details.scoreColor" />
                }
            </dd>
            <dt>{{ 'linkedItems.controls.descriptionLabel' | t: {} : assetManagementScope }}</dt>
            <dd data-uiid="linked-control-detail-description">{{ details.description }}</dd>
            <dt>{{ 'linkedItems.controls.organizationLabel' | t: {} : assetManagementScope }}</dt>
            <dd data-uiid="linked-control-detail-organization">{{ details.organization }}</dd>
            <dt>{{ 'linkedItems.controls.controlOwnerLabel' | t: {} : assetManagementScope }}</dt>
            <dd data-uiid="linked-control-detail-control-owner">{{ details.controlOwner }}</dd>
        </dl>
    </div>
</ng-template>
